import { Component, h, State, Prop } from '@stencil/core';
import '../../../stories/Components/TestFooter/TestFooter';
// import { postMessage } from '../../../utils/chatSdk';
import '../../../stories/Components/AttachmentBox/AttachmentPreview/AttachmentPreview';
import ChatSDK from 'test-iso-chat-sdk';
import { getDeviceID } from '../../../lib/helpers';
@Component({
  tag: 'chat-footer',
  shadow: true,
})
class ChatFooter {
  @State() messageBody = '';
  @Prop() isDark?: boolean;
  @Prop() conversationId: string;
  @Prop() userMetaData: any;
  @Prop() refetchMessages: () => void;
  @Prop() changeMessageSendingState: (newState: boolean) => void;
  @Prop() changeScrollToBottomState: (newState: boolean) => void;
  @Prop() updateAllMessages: (newMessages: any) => void;
  @Prop() allMessages: any;
  @State() attachmentDetails = null;
  @State() deviceId: string = '';
  @State() imagePreviewSrc: string = '';
  @State() videoPreviewSrc: string = '';
  @State() pdfPreviewSrc: string = '';
  @State() inputKey: number = 0;


  async componentWillLoad() {
    const deviceId = await getDeviceID();
    this.deviceId = deviceId;
  }

  private debounceTimeout: any;

  handleInputChange = (event: any) => {
    this.messageBody = event.detail.value;
    this.debounceApiCall();
    
  };
  debounceApiCall = () => {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.postTyping(); 
    }, 300); 
  };
  postTyping = async() => {
  await ChatSDK.getInstance().message.postIndicateTyping({conversationId:this.conversationId});
  };

  /////
  handleFileUpload = (event: CustomEvent) => {
    const { file } = event.detail;

    this.attachmentDetails = file;
    if (file) {
      const reader = new FileReader(); // Create a FileReader to read the file
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const fileType = file.type.split('/')[0];
        if (fileType === 'image') {
          this.imagePreviewSrc = e.target?.result as string;
        } else if (fileType === 'video') {
          this.videoPreviewSrc = e.target?.result as string;
        }else if (fileType.startsWith('application')) {
          this.pdfPreviewSrc = e.target?.result as string;
        }
      };
      reader.readAsDataURL(file); // Read the file as a Data URL (base64)
    }
  };

  handleSendMessage = async () => {

    if (!this.messageBody.trim() && !this.attachmentDetails) {
      const singleLineText = this.messageBody.replace(/\n/g, ' ');
      this.messageBody = singleLineText;
      return;
    }

    this.changeScrollToBottomState(true);
    const conversationId = this.conversationId;
    const body = this.messageBody.trim();
    this.messageBody = '';
    if (body) {
      this.updateAllMessages([
        ...this.allMessages,
        { body: body, messageId: '12', deliveredToAll: 'pending', senderId: this.userMetaData.userId , sentAt: Date.now()},
      ]);
      this.changeMessageSendingState(true);
      try {
        const res = await ChatSDK.getInstance().message.postMessages({
          showInConversation: true,
          messageType: 0,
          searchableTags: [body.slice(2).trim(), body.slice(3).trim()],
          encrypted: false,
          conversationId: conversationId,
          deviceId: this.deviceId,
          body: body,
        });
        const newMessages = [...this.allMessages];
        const indexOfLastMessage = newMessages.findIndex(message => message.messageId == "12");
        const lastMessage = newMessages[indexOfLastMessage];
        const lastNewMessage = { ...lastMessage, messageId: res.messageId, deliveredToAll: false };
        newMessages.splice(indexOfLastMessage, 1, lastNewMessage);
        this.updateAllMessages(newMessages);
      } catch (error) {
        console.log(error, 'postMessages error for text');
      } finally {
        this.changeMessageSendingState(false);
      }
      this.inputKey++;
    }
    /////
    else if (this.attachmentDetails) {
      this.changeMessageSendingState(true);
      const mediaId = this.attachmentDetails.lastModified + '';

      let mediaType;
      const fileType = this.attachmentDetails.type;

      if (fileType.startsWith('image/')) {
        mediaType = 0;
      } else if (fileType.startsWith('video/')) {
        mediaType = 1;
      } else if (fileType.startsWith('audio/')) {
        mediaType = 2;
      } else {
        mediaType = 3;
      }
      const attachments = [
        {
          nameWithExtension: this.attachmentDetails.name,
          mediaType: mediaType,
          mediaId: mediaId,
          mimeType: this.attachmentDetails.type,
          size: this.attachmentDetails.size,
          file: this.attachmentDetails,
        },
      ];

      //
      this.updateAllMessages([
        ...this.allMessages,
        {
          body: '',
          messageId: '12',
          deliveredToAll: 'pending',
          senderId: this.userMetaData.userId,
          sentAt: Date.now(),
          attachments: [{ mediaUrl: this.imagePreviewSrc || this.videoPreviewSrc || this.pdfPreviewSrc, mimeType: this.attachmentDetails.type }],
        },
      ]);
      this.pdfPreviewSrc='';
      this.videoPreviewSrc = '';
      this.imagePreviewSrc  = '';
      this.messageBody = '';
      //
      const payLoadForPutApi = this.attachmentDetails;
      this.attachmentDetails = null;
      try {
        const res = await ChatSDK.getInstance().message.postMessagesPresignedurls({ conversationId: conversationId, attachments: attachments });
        if (res?.presignedUrls) {
          const mediaId = res?.presignedUrls?.[0]?.mediaId;
          const mediaUrl = res?.presignedUrls?.[0]?.mediaUrl;
          const thumbnailUrl = res?.presignedUrls?.[0]?.thumbnailUrl;

          const attachmentPayload = attachments?.[0];
          const fileExtensionType = attachmentPayload?.mimeType.split('/')[1];

          const newPayload = {
            mediaId: mediaId,
            mediaUrl: mediaUrl,
            thumbnailUrl: thumbnailUrl,
            attachmentType: 0,
            mimeType: attachmentPayload.mimeType,
            name: attachmentPayload.nameWithExtension,
            extension: fileExtensionType,
            size: attachmentPayload.size,
          };
          const mediaPresignedUrl = res.presignedUrls[0].mediaPresignedUrl;
          try {
             await fetch(mediaPresignedUrl, {
              method: 'PUT',
              body: payLoadForPutApi,
              headers: {
                'Content-Type': fileType,
              },
            });

            try {
              const res = await ChatSDK.getInstance().message.postMessages({
                showInConversation: true,
                messageType: 0,
                encrypted: false,
                conversationId,
                body: 'attachment',
                // @ts-expect-error
                attachments: [newPayload],
                deviceId: this.deviceId,
              });
              
              const newMessages = [...this.allMessages];
              const indexOfLastMessage = newMessages.findIndex(message => message.messageId == "12");
              const lastMessage = newMessages[indexOfLastMessage];
              const lastNewMessage = { ...lastMessage, messageId: res.messageId, deliveredToAll: false };
              newMessages.splice(indexOfLastMessage, 1, lastNewMessage);
              this.updateAllMessages(newMessages);
            } catch (error) {
              console.log(error, 'postMessages error for media');
            }
          } catch (error) {
            console.log(error, 'error for verify media in put request');
          }
        }
      } catch (error) {
        console.log(error, 'Error while uploading the media for Presignedurls');
      } finally {
        this.changeMessageSendingState(false);
      }
      this.inputKey++;
    }
  };


  componentDidLoad() {
    document.addEventListener('keydown', this.handleEnterPress);
  }

  handleEnterPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.handleSendMessage();
    }
  };



  render() {

    const contentType = this.attachmentDetails ? this.attachmentDetails.type.split('/')[0] : '';
    const fileName = this.attachmentDetails ? this.attachmentDetails.name : '';

    return (
      <div>
        {this.attachmentDetails && (
          <attachment-preview
            onClose={() => (this.attachmentDetails = null)}
            width="150px"
            height="150px"
            bgColor="#EFF1FA"
            padding="3px"
            margin="10px 0 0 0"
            contentType={contentType}
            content={contentType === 'image' ? this.imagePreviewSrc : contentType === 'video' ? this.videoPreviewSrc : fileName}
          />
        )}
        <my-test-footer
        key={this.inputKey}
          inputValue={this.messageBody}
          onFileUploaded={this.handleFileUpload}
          oninput-change={this.handleInputChange}
          onSendClick={this.handleSendMessage}
          bgColor = {'var(--chat-footer-bg)'}
          inputBgColor ={'var(--chat-footer-input-bg)'}
          inputFontColor = {'var(--chat-footer-input-text)'}
          inputContainerBorderColor = {'var(--chat-footer-input-border)'}
          attachmentIconColor = {'var(--chat-footer-attachment-icon)'}
        ></my-test-footer>
      </div>
    );
  }
}

export { ChatFooter };
